import Notification from './notification.vue'
import Vue from 'vue'
import { camelcaseToHyphen } from '../../../utils/assist'
import * as constants from '../../../utils/constants'

Notification.newInstance = properties => {
  const _props = properties || {}
  let props = ''
  Object.keys(_props).forEach(prop => {
    // 构造出适合vue写法的属性实现初始化组件
    props += ' :' + camelcaseToHyphen(prop) + '=' + prop
  })
  const div = document.createElement('div')
  div.innerHTML = `<notification${props}></notification>`
  document.body.appendChild(div)
  // 获取初始化的组件实例
  const notification = new Vue({
    el: div,
    data: _props,
    components: {Notification}
  }).$children[ 0 ]
  return {
    // 新加一个notice组件
    notice (noticeProps) {
      notification.add(noticeProps)
    },
    remove (name) {
      notification.close(name)
    },
    component: notification,
    destroy () {
      notification.closeAll()
      setTimeout(function () {
        document.body.removeChild(
          document.getElementsByClassName(`${constants.PREFIX_CLASS}message`)[ 0 ].parentElement)
      }, 500)
    }
  }
}
export default Notification



// WEBPACK FOOTER //
// ./src/components/base/notification/index.js